/*
 * Copyright (c) 2025 by PROS, Inc.  All Rights Reserved.
 * This software is the confidential and proprietary information of
 * PROS, Inc. ("Confidential Information").
 * You may not disclose such Confidential Information, and may only
 * use such Confidential Information in accordance with the terms of
 * the license agreement you entered into with PROS.
 */
/**
 * Supported Locales.
 */
export const SupportedLocale = {
    en_US: 'en_US',
    fr_FR: 'fr_FR',
};
/**
 * AI Chat Network Errors.
 */
export const AiChatNetworkError = {
    NONE: 'NONE',
    CONNECTIVITY_ISSUES: 'CONNECTIVITY_ISSUES',
    GENERATING_RESPONSE: 'GENERATING_RESPONSE',
    INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
    INVALID_REQUEST: 'INVALID_REQUEST',
};
/**
 * Message Parts.
 */
export const MessagePartKind = {
    PART_REF: 'part-ref',
    MARKDOWN: 'chat-ui-text-output',
    HIGHCHARTS: 'chat-ui-highcharts-chart',
    TEXT: 'text',
};
/**
 * A user defined type guard to assert that the item is a markdown one.
 */
export function isMarkdownMessagePart(messagePart) {
    return messagePart.kind === MessagePartKind.MARKDOWN;
}
/**
 * A user defined type guard to assert that the item is a text one.
 */
export function isTextMessagePart(messagePart) {
    return messagePart.kind === MessagePartKind.TEXT;
}
/**
 * A user defined type guard to assert that the item is a highcharts one.
 */
export function isHighchartsMessagePart(messagePart) {
    return messagePart.kind === MessagePartKind.HIGHCHARTS;
}
/**
 * Messages.
 */
export const ChatMessageKind = {
    HUMAN: 'human',
    AI: 'ai',
    WELCOME_MESSAGE: 'welcome-message',
    SUGGESTED_PROMPTS: 'suggested_prompts',
};
/**
 * Reactions.
 */
export const Reaction = {
    POSITIVE: 'POSITIVE',
    NEGATIVE: 'NEGATIVE',
};
//# sourceMappingURL=model.js.map